import { render, staticRenderFns } from "./ExpandableBiomes.vue?vue&type=template&id=786d476b&scoped=true&"
import script from "./ExpandableBiomes.vue?vue&type=script&lang=js&"
export * from "./ExpandableBiomes.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableBiomes.vue?vue&type=style&index=0&id=786d476b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786d476b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
